import { render, staticRenderFns } from "./CellRenderCommentModal.vue?vue&type=template&id=fbdb4d48&scoped=true&"
import script from "./CellRenderCommentModal.vue?vue&type=script&lang=js&"
export * from "./CellRenderCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdb4d48",
  null
  
)

export default component.exports